import { PagedResult, Result } from "../../../models/Result";
import { BoricaPaymentListItem, StatusChangeItem, TransactionListItem, UpdatePayDutyStatusRequest, UpdatePayDutyStatusResponse } from "../../../models/BoricaTransaction";
import { httpService } from "../../HttpService";
import { SearchRequestBaseModel } from "../../../models/SearchRequestModel";

class BoricaTransactionApiService {
    path: string = "BoricaTransaction";

    searchTransactions = async (request: SearchRequestBaseModel): Promise<PagedResult<TransactionListItem[]>> =>
        await httpService.getPage<TransactionListItem[]>(`${this.path}/search`, request);

    searchBoricaPayments = async (request: SearchRequestBaseModel): Promise<PagedResult<BoricaPaymentListItem[]>> =>
        await httpService.getPage<BoricaPaymentListItem[]>(`${this.path}/borica-payments`, request);

    searchStatusChanges = async (request: SearchRequestBaseModel): Promise<PagedResult<StatusChangeItem[]>> =>
        await httpService.getPage<StatusChangeItem[]>(`${this.path}/status-changes`, request);

    updateStatus = async (request: UpdatePayDutyStatusRequest): Promise<Result<UpdatePayDutyStatusResponse>> =>
        await httpService.put<UpdatePayDutyStatusResponse>(`${this.path}/update-status`, request);

    exportTransactionsCsv = async (request: SearchRequestBaseModel): Promise<Result<string>> =>
        await httpService.post<string>(`${this.path}/export-transactions`, request);

    exportBoricaPaymentsCsv = async (request: SearchRequestBaseModel): Promise<Result<string>> =>
        await httpService.post<string>(`${this.path}/export-borica-payments`, request);
}

const boricaTransactionApiService = new BoricaTransactionApiService();
export { boricaTransactionApiService };
